import { useState } from 'react';
import { useSelector } from 'react-redux';
import { api } from '../redux/axios/api';
import { servicios } from '../redux/helpers';

const useMaestro = () => {
  const { currentUser } = useSelector((state) => state.app);
  const [maestros, setMaestros] = useState([]);
  const [processingMaestro, setProcessingMaestro] = useState(false);

  const getMaestros = (valor) => {
    setProcessingMaestro(true);
    api
      .get(`${servicios.MAESTRO}/${valor}/detalles`)
      .then((response) => {
        setMaestros(response);
      })
      .catch(() => {
        setMaestros([]);
      })
      .finally(() => setProcessingMaestro(false));
  };

  const getDetails = (valor) => {
    setProcessingMaestro(true);
    api
      .get(`${servicios.DETALLE}/${valor}/cabecera`, {
        params: { ie: currentUser.ie },
      })
      .then((response) => {
        setMaestros(response);
      })
      .catch(() => {
        setMaestros([]);
      })
      .finally(() => setProcessingMaestro(false));
  };

  return {
    maestros,
    processingMaestro,
    getMaestros,
    getDetails,
  };
};

export default useMaestro;
